"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var i18n_1 = __importDefault(require("../i18n"));

var _CompareBase = {
  equal: false,
  larger: false,
  smaller: false,
  include: false,
  on: -1
};

function buildOptions() {
  return [{
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Equal'),
    id: "Equal",
    compare: {
      equal: true,
      larger: false,
      smaller: false
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Larger'),
    id: 'Larger',
    compare: {
      equal: false,
      larger: true
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Equal_Larger'),
    id: 'Equal_Larger',
    compare: {
      equal: true,
      larger: true
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Smaller'),
    id: 'Smaller',
    compare: {
      equal: false,
      smaller: true
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Equal_Smaller'),
    id: 'Equal_Smaller',
    compare: {
      equal: true,
      smaller: true
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Include'),
    id: "Include",
    compare: {
      include: true
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Switched_On'),
    id: 'Switched_On',
    compare: {
      on: 1
    }
  }, {
    text: i18n_1.default.t('Filter_User_Input_Relation_Action_Switched_Off'),
    id: 'Switched_Off',
    compare: {
      on: 0
    }
  }];
}

function getCompareOptions() {
  var options = buildOptions();
  return options.map(function (v) {
    return {
      text: v.text,
      id: v.id
    };
  });
}

exports.getCompareOptions = getCompareOptions;

function convertCompareIdToObject(id) {
  var found = lodash_1.default.find(buildOptions(), {
    id: id
  });

  if (found !== undefined) {
    return Object.assign({}, _CompareBase, found.compare);
  } else {
    return _CompareBase;
  }
}

exports.convertCompareIdToObject = convertCompareIdToObject;

function convertCompareObjectToOption(compare) {
  var found = lodash_1.default.find(buildOptions(), function (u) {
    return lodash_1.default.isMatch(compare, u.compare);
  });
  return found;
}

exports.convertCompareObjectToOption = convertCompareObjectToOption;

function convertCompareObjectToId(compare) {
  var found = convertCompareObjectToOption(compare);

  if (found) {
    return found.id;
  } else {
    return '';
  }
}

exports.convertCompareObjectToId = convertCompareObjectToId;

function convertCompareObjectToText(compare) {
  if (!compare) {
    return '';
  }

  var found = convertCompareObjectToOption(compare);

  if (found) {
    return found.text;
  } else {
    return '';
  }
}

exports.convertCompareObjectToText = convertCompareObjectToText;